import { useEffect } from "react";

// D1 · En la ficha, Enter = acción (p. ej. "+ A la cola"). Ignora textareas, botones y listas desplegadas.
export function useEnterKey(ref, action, enabled = true) {
  useEffect(() => {
    const el = ref.current;
    if (!el || !enabled) { return undefined; }
    const onKey = (e) => {
      if (e.key !== "Enter" || e.shiftKey || e.isComposing) return;
      const t = e.target;
      if (t.tagName === "TEXTAREA" || t.tagName === "BUTTON" || t.getAttribute?.("role") === "combobox" || t.closest?.("[role=listbox]")) return;
      e.preventDefault();
      action();
    };
    el.addEventListener("keydown", onKey);
    return () => { el.removeEventListener("keydown", onKey); };
  }, [ref, action, enabled]);
}
